import React, {PropsWithChildren} from 'react';
import {Theme, Typography} from "@mui/material";
import {SxProps} from "@mui/system/styleFunctionSx";

interface TitleOptions {
    upperCase?: boolean;
    children: any;
    sx?: SxProps<Theme>;
}

export function Title(props: TitleOptions) {
    let textTransform: any = props.upperCase ? 'uppercase' : '';
    return <Typography fontWeight="700" textTransform={textTransform} color={(theme: any) => theme.palette.text.primary} fontSize={18} whiteSpace="nowrap" {...props}>{props.children}</Typography>
}

interface SubTitleOptions {
    upperCase?: boolean;
    children: any;
    sx?: SxProps<Theme>;
}

export function SubTitle(props: SubTitleOptions) {
    let textTransform: any = props.upperCase ? 'uppercase' : '';
    return <Typography fontWeight="700" textTransform={textTransform} color={(theme) => theme.palette.text.secondary} fontSize={13} {...props}>{props.children}</Typography>
}

export function Text(props: PropsWithChildren) {
    return <Typography color="text.primary" fontSize={16} {...props}>{props.children}</Typography>
}